import { PageNumbers } from '@catalog/const';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { CatalogState, StateWithCatalog } from '../catalog-state';
import { getCustomCatalogState } from './feature.selector';

type ProductListLoadingState = CatalogState['productListLoading'];

export const getProductListLoadingState: MemoizedSelector<StateWithCatalog, ProductListLoadingState> = createSelector(
  getCustomCatalogState,
  (state: CatalogState) => state.productListLoading,
);

export const getProductListLoading: MemoizedSelector<StateWithCatalog, boolean> = createSelector(
  getProductListLoadingState,
  (state: ProductListLoadingState) => Boolean(state.loading),
);

export const getProductListMoreLoading: MemoizedSelector<StateWithCatalog, boolean> = createSelector(
  getProductListLoadingState,
  (state: ProductListLoadingState) => Boolean(state.loadingMore),
);

export const getProductListLoadingSuggestions: MemoizedSelector<StateWithCatalog, boolean> = createSelector(
  getProductListLoadingState,
  (state: ProductListLoadingState) => Boolean(state.loadingSuggestions),
);

export const getProductListLoadingPageNumbers: MemoizedSelector<StateWithCatalog, PageNumbers> = createSelector(
  getProductListLoadingState,
  (state: ProductListLoadingState) => state.pageNumbers || { prev: 0, next: 0 },
);
